import {Component} from 'panel';

import {TooltipBulletStyle, TooltipItemType} from './types';

import template from './index.jade';
import css from './index.styl?inline';

export default class ChartTooltip extends Component<ChartTooltip> {
  get config() {
    return {
      template,
      useShadowDom: true,
      css,
      helpers: {
        TooltipItemType,
        getItemBackground: (item) => {
          const {bulletStyle, color} = item;
          return bulletStyle === TooltipBulletStyle.Solid
            ? color
            : `repeating-linear-gradient(45deg, ${color}, ${color} 3px, #FFFFFF 3px, #FFFFFF 6px)`;
        },
      },
    };
  }

  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      'footer-text': {type: `string`},
      sections: {
        type: `json`,
        description: `interface: TooltipItem[][]. outer array represents a block, inner array represents a line. Can also display subsections`,
      },
      'title-color': {type: `string`},
    };
  }
}

customElements.define(`mp-chart-tooltip`, ChartTooltip);
